// The square at the start of a tile in the Library's Free resources strip: the item's own glyph in its
// look (the scorecard's 22, the guide's 21), or, where the item has its own cover photo (3 Nov), the
// photo cropped to fill the square. Empty while the photo's link is on its way; the glyph again if the
// photo can't be had. small: the phone's 56px square.
import { coverState } from '../free/covers.js'

export function FreeGlyph({ item, covers, small = false }) {
  const size = small ? 'glyph glyph--small' : 'glyph'
  const photo = coverState(covers, item)
  if (photo) {
    return (
      <span className={`${size} glyph--cover`} aria-hidden="true">
        {photo.url && <img key={photo.url} className="glyph-img" src={photo.url} alt="" decoding="async"
          onError={e => covers.failed(item, e.currentTarget.src)} onLoad={e => covers.loaded(item, e.currentTarget.src)} />}
      </span>
    )
  }
  return <span className={`${size} glyph--${item.tone}`}>{item.glyph}</span>
}
